import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import qs from 'qs';

import { Button, Popover } from '@salesforce/design-system-react';
import { SetupStep } from './';
import redirectToError from '../../utilities/redirectToError';

import './DeleteTags.scss';

export class DeleteTags extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popoverState: {
        showDeletePrompt: false
      }
    };
  }

  componentDidUpdate(prevProps) {
    //todo: handle both success and error state toasts here
  }

  handleDelete() {
    const status = this.props.activation.status;
    if (status === 'pause') {
      const parsedQueryString = qs.parse(this.props.location.search.substr(1));
      this.props.actions.submitActivationStatusChange(
        {
          ...parsedQueryString,
          onError: redirectToError(this.props.history)
        },
        'toDelete'
      );
    }
  }

  handleDeleteCancel() {
    this.setState({
      popoverState: {
        showDeletePrompt: false
      }
    });
  }

  handleDeletePrompt() {
    this.setState({
      popoverState: {
        showDeletePrompt: true
      }
    });
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { status } = this.props.activation;
    const hiddenStates = ['inactive', 'deleted', undefined];
    if (hiddenStates.indexOf(status) !== -1) {
      return null;
    } else {
      return (
        <div className="delete-tags">
          <SetupStep
            step={1}
            hideProgress={true}
            complete={false}
            title={formatMessage({ id: 'DeleteTags.title' })}
            description={formatMessage({ id: 'DeleteTags.description' })}
            rightNav={
              <div>
                <Popover
                  className="delete-tags-prompt slds-popover_large"
                  isOpen={this.state.popoverState.showDeletePrompt}
                  body={
                    <div>
                      <p>{formatMessage({ id: 'DeleteTags.Prompt.body.1' })}</p>
                      <p>{formatMessage({ id: 'DeleteTags.Prompt.body.2' })}</p>
                    </div>
                  }
                  footer={
                    <div className="slds-text-align_right">
                      <Button
                        label={formatMessage({
                          id: 'DeleteTags.Prompt.cancel'
                        })}
                        onClick={() => this.handleDeleteCancel()}
                      />
                      <Button
                        label={formatMessage({
                          id: 'DeleteTags.Prompt.apply'
                        })}
                        variant="destructive"
                        onClick={() => this.handleDelete()}
                      />
                    </div>
                  }
                  heading={formatMessage({
                    id: 'DeleteTags.Prompt.heading'
                  })}
                  id="popover-controlled-with-footer"
                  onRequestClose={() => this.handleDeleteCancel()}
                >
                  <Button
                    variant="neutral"
                    onClick={() => this.handleDeletePrompt()}
                    disabled={status !== 'pause'}
                  >
                    <FormattedMessage id="DeleteTags.apply" />
                  </Button>
                </Popover>
              </div>
            }
          />
        </div>
      );
    }
  }
}

DeleteTags.propTypes = {
  activation: PropTypes.object,
  children: PropTypes.element,
  location: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(DeleteTags);
